(() => {
    let lastTime = null;
    let lastPos = null;
    let movements = [];

    function verify() {
        var rid = document.body.getAttribute('r-id');
        var data = new FormData();
        //data.append("id", getSignature());
        data.append("id", rid);
        try {
            fetch('/traffic/' + rid, {
                method: 'POST',
                body: data
            }).then(response => {
                try {
                    response.json().then((responseData) => {                                    
                        document.body.dispatchEvent(new CustomEvent('ag.tsm.valid', { detail: responseData }));
                    });
                } catch (e) {}
                window.location.reload();
            }).catch(e => { window.location.reload(); })
        } catch (error) {
            window.location.reload();
        }
    }

    function report() {
        var rid = document.body.getAttribute('r-id');
        var data = new FormData();
        data.append("id", getSignature());
        try {
            fetch('/traffic/report', {
                method: 'POST',
                body: data
            }).then(response => {
                try {
                    response.json().then((responseData) => {                                    
                        window.location.reload();
                    });
                } catch (e) {}                
            }).catch(e => {  })
        } catch (error) {
            
        }
    }

    function getCurrentValue() {
        if (window.localStorage.getItem('TSM') != null) return JSON.parse(window.localStorage.getItem('TSM'));
        return null;
    }

    function setCurrentValue(tsmValue){
        if(tsmValue==undefined || tsmValue==null)
            window.localStorage.removeItem('TSM');
        else
            window.localStorage.setItem('TSM', JSON.stringify(tsmValue));
    }

    function resetTSMValidation() {
        try{
            if (getCurrentValue() != null) {
                var valueToReset = getCurrentValue();
                delete valueToReset.id;
                delete valueToReset.token;
                if (valueToReset)
                    setCurrentValue(valueToReset);
                else
                    setCurrentValue(null);
            }
        }catch(e){}
    }

    

    function verifyUpdate(engageValidation) {
        var rid = document.body.getAttribute('r-id');
        var currentValue = getCurrentValue();
        var data = new FormData();
        data.append("id", getSignature());
        data.append("oldId", currentValue.id);
        data.append("token", currentValue.token);
        if(!incrementVerifyUpdateCount()){
            resetTSMValidation();
        }
        else{
            setCurrentValue(null);
            report();
            return;            
        }
        try {
            fetch('/traffic/' + rid, {
                method: 'POST',
                body: data
            }).then(response => {
                try {
                    response.json().then((responseData) => {                                    
                        document.body.dispatchEvent(new CustomEvent('ag.tsm.valid', { detail: responseData }));
                        window.location.reload();
                    }).catch(()=>{
                        engageValidation(true);
                    });
                } catch (e) { engageValidation(true); }                            
            }).catch(e => { engageValidation(true); })
        } catch (error) {
            engageValidation(true);
        }
    }

    function getSignature() {

        var singnatureSamples = movements.filter((x, i) => { return i < 16 });
        var signatureValue = singnatureSamples.reduce((x, y, i) => {
            return x + '|' + Math.round(y.dx + y.dy + y.dt + y.velocity);
        }, '');
        return btoa(signatureValue);
    }

    function incrementVerifyUpdateCount(){
        var currentValue = getCurrentValue();
        if(!currentValue||currentValue==null)
            currentValue={};
        if(currentValue.verifyUpdateCount) currentValue.verifyUpdateCount++;
        else currentValue.verifyUpdateCount=1;
        setCurrentValue(currentValue); 
        if(currentValue.verifyUpdateCount>2)return true;
        return false;      
    }

    function recordMovement(x, y) {
        const now = Date.now();
        if (lastPos && lastTime) {
            const dx = x - lastPos.x;
            const dy = y - lastPos.y;
            const dt = now - lastTime;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const velocity = distance / dt;
            movements.push({ dx, dy, dt, velocity });
        }
        lastPos = { x, y };
        lastTime = now;
    }

    function listen(isReset) {

        if(isReset)
            resetTSMValidation();
        document.addEventListener("mousemove", e => recordMovement(e.clientX, e.clientY));

        document.addEventListener("touchstart", e => {
            const t = e.touches[0];
            recordMovement(t.clientX, t.clientY);
        });

        document.addEventListener("touchend", e => {
            const t = e.touches[0];
            recordMovement(t.clientX, t.clientY);
        });

        document.addEventListener("touchmove", e => {
            const t = e.touches[0];
            recordMovement(t.clientX, t.clientY);
        });        

        function isHuman(limit) {
            if (movements.length < (limit ? limit : 20)) return false;
            let varying = movements.some((m, i, arr) => i > 0 && (Math.abs(m.velocity - arr[i - 1].velocity) > 0.05));
            let nonLinear = movements.some((m, i, arr) => i > 1 && (Math.abs(m.dx - arr[i - 1].dx) > 0.1 || Math.abs(m.dy - arr[i - 1].dy) > 0.1));
            let irregular = movements.some(m => m.dt > 50 && m.dt < 500);
            return varying && nonLinear && irregular;
        }
        var checkMaxCount = 0;
        var haveTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        if (haveTouch) checkMaxCount = 0;
        var checkCount = 0;
        var valuation = setInterval(() => {
            checkCount++;
            if (isHuman() && window.location.href.indexOf('.html') < 0) {
                clearInterval(valuation);
                verify();
            }
            if (checkCount > checkMaxCount) {
                clearInterval(valuation);
                document.body.classList.remove('auto');
                var actionButton = document.querySelector('p');
                var actionButtonBounds = actionButton.getBoundingClientRect();
                var actionButtonComputedStyle = getComputedStyle(actionButton);
                var actionButtonOffset = parseInt(actionButtonComputedStyle.paddingTop.replace(/[^0-9\.]/gi, ''));
                var actionLeft = actionButtonBounds.left + actionButtonOffset;
                var actionRight = actionLeft + actionButtonOffset * 3.6;
                var actionTop = actionButtonBounds.top + actionButtonOffset;
                var actionBottom = actionTop + actionButtonOffset * 3.6;
                actionButton.onclick = (e) => {
                    if (actionLeft < e.x && e.x < actionRight && actionTop < e.y && e.y < actionBottom) {
                        document.body.classList.add('verified');
                        verify();
                    }
                };
                
                actionButton.ontouchstart = (e) => {
                    var x = e.touches[0].pageX;
                    var y = e.touches[0].pageY;
                    var offsetValue = 16; // touch offset
                    if (actionLeft - offsetValue < x && x < actionRight + offsetValue && actionTop - offsetValue < y && y < actionBottom + offsetValue) {
                        document.body.classList.add('verified');
                        verify();
                    }
                };
            }
        }, checkMaxCount==0?10:1000);
    }
    window.onfocus = function () {
        if (getCurrentValue() != null) window.location.reload();
    };    
    var currentValueInit = getCurrentValue();
    if (currentValueInit != null && currentValueInit.id && currentValueInit.token && currentValueInit.token!='UN' && currentValueInit.token!='NA') {
        verifyUpdate(()=>{});
    }

    listen();
    document.addEventListener('DOMContentLoaded', (event) => {

        try {
            document.querySelector('.bot-issue label').addEventListener('click', (e) => { 
                if (getCurrentValue() != null) setCurrentValue(null);
                e.target.remove();
                report(); 
            });
        } catch (e) {}
        try{
            var bodyClass = window.getComputedStyle(document.body, ':after').getPropertyValue('content');
            if (typeof (bodyClass) == 'string' && bodyClass != '')
                document.body.classList += ' ' + bodyClass.replace(/"/gi, '');                
        }catch(e){}


        setTimeout(() => {
            var headerColor =  '#fff';
            var headerElement = document.createElement('header');
            headerElement.className = 'mdl-layout__header item-h';
            headerElement.style.opacity = '0';
            document.body.prepend(headerElement);
            headerColor = window.getComputedStyle(headerElement).getPropertyValue('background-color');
            headerElement.remove();
            var customStyle = document.createElement('style');
            customStyle.innerHTML = `
            .header {
                background: ${headerColor};
            }
            body .bot-human p,body .bot-message p,body .bot-message h1,body h2.error,body.inverse footer h3 {
                color: inherit!important;
            }`;
            document.head.appendChild(customStyle);
        },10);
    });        

})();